import React, { useState } from 'react';
import styles from './css/shortterm.module.css';
import { NavLink} from 'react-router-dom';

import { CiClock1, CiBoxList, CiCalendar, CiLaptop } from "react-icons/ci";

import msoffice from '../../../assets/ms-office.webp'
import webdesign from '../../../assets/web-design.webp'
import graphics from '../../../assets/graphics-design.webp'
import digitalmarketing from '../../../assets/digital-marketing.webp'
import fullstack from '../../../assets/fullstackweb.jpg'
import dataanalysis from '../../../assets/data-analysis.webp'
import java from '../../../assets/java-programming.avif'
import python from '../../../assets/python-programming.jpg'
import cpp from '../../../assets/C++.avif'
import csharp from '../../../assets/csharp.jpg'
import uiux from '../../../assets/uiux.webp'

const courses = [
  {
    id: 1,
    name: 'MS Office Suite',
    image: msoffice,
    duration: '2 Months',
    details: [
      'MS Word', 'MS Excel', 'MS PowerPoint', 'MS Outlook', 'Email', 'Internet Surfing'
    ],
    benefits: [
      'Master everyday office productivity tools',
      'Prepare professional reports and presentations',
      'Improve organizational communication through emails'
    ],
    schedule: '6 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 2,
    name: 'Web Design',
    image: webdesign,
    duration: '3 Months',
    details: [
      'HTML5', 'CSS', 'Bootstrap', 'ECMA Script/JavaScript'
    ],
    benefits: [
      'Build professional and responsive websites',
      'Understand how web technologies work together',
      'Foundation for becoming a frontend developer'
    ],
    schedule: '8 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 3,
    name: 'Graphics Design',
    image: graphics,
    duration: '2 Months',
    details: [
      'Adobe Photoshop', 'CorelDraw', 'Adobe Illustrator'
    ],
    benefits: [
      'Create stunning visual content',
      'Master popular design software',
      'Build a professional design portfolio'
    ],
    schedule: '8 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 4,
    name: 'Advanced Digital Marketing',
    image: digitalmarketing,
    duration: '4 Months',
    details: [
      'Basic Marketing', 'SEO', 'Creating Display Ads', 'Email Marketing', 'Social Media Marketing',
      'Internet Advertising with SEO', 'Google Analytics', 'Lead Generation'
    ],
    benefits: [
      'Master social media and online advertising',
      'Learn how to generate and convert leads',
      'Prepare for Google and SEO certifications'
    ],
    schedule: '6 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 5,
    name: 'Fullstack Web Development',
    image: fullstack,
    duration: '5 Months',
    details: [
      'HTML', 'CSS', 'JavaScript', 'Bootstrap', 'Python', 'MySQL'
    ],
    benefits: [
      'Develop full end-to-end websites and applications',
      'Become job-ready for junior developer roles',
      'Hands-on backend and frontend coding experience'
    ],
    schedule: '8 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 6,
    name: 'Data Analysis',
    image: dataanalysis,
    duration: '5 Months',
    details: [
      'Excel', 'Tableau', 'Power BI', 'Python', 'MySQL'
    ],
    benefits: [
      'Extract and visualize valuable business insights',
      'Use industry-leading tools like Power BI',
      'Start a career in business intelligence and analytics'
    ],
    schedule: '8 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 7,
    name: 'Java Programming Language',
    image: java,
    duration: '3 Months',
    details: [
      'Introduction to Java', 'Data Types', 'Variables', 'Control Structures', 'OOP Concepts', 'File Handling'
    ],
    benefits: [
      'Master the basics of a powerful backend language',
      'Solid foundation for Android development',
      'Prepare for Java certifications'
    ],
    schedule: '8 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 8,
    name: 'Python Programming Language',
    image: python,
    duration: '2 Months',
    details: [
      'Introduction to Python', 'Control Structures', 'Functions', 'Loops', 'Advanced Data Types',
      'OOP', 'File Handling', 'Exceptions'
    ],
    benefits: [
      'Fastest growing language in tech',
      'Perfect for data science and web development',
      'Easy to learn and versatile'
    ],
    schedule: '8 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 9,
    name: 'C++ Programming',
    image: cpp,
    duration: '2 Months',
    details: [
      'Introduction to C++', 'Data Types', 'Variables', 'Control Structures', 'Functions',
      'Arrays', 'Pointers', 'OOP', 'File Handling', 'Memory Management'
    ],
    benefits: [
      'Strong base in software development',
      'C++ is used in game dev and high-performance apps',
      'Learn low-level memory management'
    ],
    schedule: '8 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 10,
    name: 'C# Programming',
    image: csharp,
    duration: '2 Months',
    details: [
      'Introduction to C#', 'Data Types', 'Variables', 'Control Structures', 'Functions',
      'Arrays', 'Collections and Generics', 'OOP', 'File Handling', 'LINQ', 'Exceptions'
    ],
    benefits: [
      'Develop Windows desktop applications',
      'Build games with Unity (C# backend)',
      'Learn a language closely tied to Microsoft ecosystem'
    ],
    schedule: '8 Hours Per Week',
    format: 'Onsite / Online',
  },
  {
    id: 11,
    name: 'UI/UX Design',
    image: uiux,
    duration: '2 Months',
    details: [
      'Product Design with Figma', 'Design Thinking', 'User Research', 'Information Architecture', 'Wireframing', 'Prototyping'
    ],
    benefits: [
      'Learn industry-standard tools like Figma',
      'Understand user-centered design principles',
      'Create real-world digital product designs'
    ],
    schedule: '8 Hours Per Week',
    format: 'Onsite / Online',
  },
];

export default function ShortTerm() {
  const [selectedCourse, setSelectedCourse] = useState(null);

  return (
    <section className={styles.shortTermSection}>
      <h2 className={styles.title}>Short-Term Courses</h2>
        <p className={styles.subtitle}>Master high-demand skills in just a few months and become globally employable! Our short-term courses are designed to fast-track your career with hands-on training, expert guidance, and globally recognized certification. Start today and step confidently into global opportunities!</p>
      <div className={styles.cardContainer}>
        {courses.map((course, index) => (
          <div
            key={course.id}
            className={`${styles.card} ${styles.fadeIn}`}
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <img src={course.image} alt={course.name} className={styles.courseImage} />
            <h3 className={styles.courseName}>{course.name}</h3>
            <p>Duration: {course.duration}</p>
            <button className={styles.learnMoreBtn} onClick={() => setSelectedCourse(course)}>
              Learn More
            </button>
          </div>
        ))}
      </div>

      {selectedCourse && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h2>{selectedCourse.name}</h2>

            <p><CiClock1 className={styles.icon} /> <strong>Duration:</strong> {selectedCourse.duration}</p>

            <div className={styles.detailList}>
              <p><CiBoxList className={styles.icon} /> <strong>Full Details:</strong></p>
              <p>{selectedCourse.details.join(', ')}</p>
            </div>

            <div className={styles.detailList}>
              <p><CiBoxList className={styles.icon} /> <strong>Benefits:</strong></p>
              <ul>
                {selectedCourse.benefits.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            <p><CiCalendar className={styles.icon} /> <strong>Schedule:</strong> {selectedCourse.schedule}</p>
            <p><CiLaptop className={styles.icon} /> <strong>Format:</strong> {selectedCourse.format}</p>

            {/* <a href={selectedCourse.contactUrl} className={styles.contactBtn} target="_blank" rel="noopener noreferrer">
              Contact Us
            </a> */}
            <NavLink exact="true" to="/apply" className={styles.contactBtn}>Apply</NavLink>
            <button className={styles.closeBtn} onClick={() => setSelectedCourse(null)}>Close</button>
          </div>
        </div>
      )}
    </section>
  );
}
